import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { Routes, RouterModule } from "@angular/router";

import { IonicModule } from "@ionic/angular";

import { AuthorsPage } from "./authors.page";
import { TranslateModule } from "@ngx-translate/core";

const routes: Routes = [
    {
        path: "",
        component: AuthorsPage
    }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        RouterModule.forChild(routes),
        TranslateModule
    ],
    declarations: [AuthorsPage]
})
export class AuthorsPageModule {}
